import React from 'react';
function BMIChildrenTable({classification})  {
  return (
    <table >
      <thead>
        <tr>
          <th >Plage en percentile</th>
          <th >Catégorie de poids</th>
        </tr>
      </thead>
      <tbody>
        <tr className={classification === 'Underweight' ? 'highlightedWarning' : ''}>
          <td>Moins de 5%</td>
          <td>Insuffisance pondérale (Underweight)</td>
        </tr>
        <tr className={classification === 'Healthy weight' ? 'highlightedOk' : ''}>
          <td>De 5% à 85%</td>
          <td>Poids sain (Healthy weight)</td>
        </tr>
        <tr className={classification === 'At risk of overweight' ? 'highlightedWarning' : ''}>
          <td>De 85% à 95%</td>
          <td>Risque de surpoids (At risk of overweight)</td>
        </tr>
        <tr className={classification === 'Overweight' ? 'highlightedDanger' : ''}>
          <td>95% ou plus</td>
          <td>Surpoids (Overweight)</td>
        </tr>
        <tr>
          <td colSpan="2">
            <b>Source:</b>{' '} <br/>
            <a href="https://www.cdc.gov/bmi/faq/">
            Centres de contrôle et de prévention des maladies - Agence de santé publique nationale aux États-Unis
            </a>
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <b>Dernière révision:</b> 28/02/2026
          </td>
        </tr>
      </tbody>
    </table>
  );
}
export default BMIChildrenTable;